import Star from './Star'

const Reviews = () => {
	const reviewData = [
		{
			id: 1,
			date: 'October 13, 2024',
			stars: 5,
			img: 'AE',
			dp_color: 'bg-blue-700',
			name: 'Anas El kayli',
			review: `I had an amazing experience using this amazing car rental booking app! The interface is very user-friendly and smooth, making it easy to navigate and find exactly what I needed. I was impressed by the wide variety of vehicles available at very reasonable prices, and the booking process was quick and smooth. I recommend downloading it, it will help you a lot.`,
		},
		{
			id: 2,
			date: 'May 10, 2026',
			stars: 5,
			img: 'AH',
			dp_color: 'bg-pink-700',
			name: 'Anower Hossain',
			review: `A truly fantastic app It provided me with great discounts on car rentals, significantly lower than usual I loved how it quickly displays nearby cars and the interface is clear and easy to use On my last trip, I was able to find the perfect car in minutes, saving me a long search I highly recommend it to anyone who travels frequently or urgently needs a car`,
		},
		{
			id: 3,
			date: 'April 10, 2026',
			stars: 5,
			img: 'OO',
			dp_color: 'bg-green-700',
			name: 'Oluwasanmi Odebode',
			review: `I've tried quite a few apps over the years, but this one really stands out as the best rental car booking app I've used so far. The interface is incredibly easy to use, and everything feels like a smooth experience from searching car rentals to making payments. The app consistently shows good deals, and in many cases, I found the best prices online compared to other sites.`,
		},
	]
	return (
		<div className='lg:max-h-[495px] max-h-[50vh] overflow-y-scroll rounded-[12px] border-[0.7px] border-[#D8DFEE] py-[6px] px-3 lg:px-[130px] border-shadow '>
			{reviewData.map((review) => {
				return (
					<div
						key={review.id}
						className='py-5 border-b border-dashed'>
						<div className='flex items-center justify-start gap-3 '>
							<div
								className={`rounded-full ${review.dp_color} w-12 h-12 text-lg text-white font-extrabold p-2 aspect-square flex justify-center items-center`}>
								{review.img}
							</div>
							<div className='space-y-[4px]'>
								<p className='text-sm font-semibold lg:text-xl text-my-dark-blue'>
									{review.name}
								</p>
								<div className='flex items-center justify-start gap-1'>
									<Star count={review.stars}/>
									<p className='text-my-light-blue text-[10px] lg:text-sm'>
										{review.date}
									</p>
								</div>
							</div>
						</div>
						<p className='text-[#38478F] text-xs mt-[10px] leading-[22px]'>
							{review.review}
						</p>
					</div>
				)
			})}
		</div>
	)
}

export default Reviews
